'use client';

import '@ui5/webcomponents/dist/MultiInput.js';
import { ValueState, InputType } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * ### Overview
 *
 * A `MultiInput` field allows the user to enter multiple values, which are displayed as `Token`. User can choose interaction for creating tokens. Fiori Guidelines say that user should create tokens when:
 *
 * *   Type a value in the input and press enter or focus out the input field (`onChange` event is fired)
 * *   Select a value from the suggestion list (`onSuggestionItemSelect` event is fired)
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-MultiInput)
 */
const MultiInput = withWebComponent('ui5-multi-input', ['accessibleName', 'accessibleNameRef', 'maxlength', 'name', 'placeholder', 'type', 'value', 'valueState'], ['showValueHelpIcon', 'disabled', 'noTypeahead', 'readonly', 'required', 'showClearIcon', 'showSuggestions'], ['tokens', 'icon', 'valueStateMessage'], ['token-delete', 'value-help-trigger', 'change', 'input', 'suggestion-item-preview', 'suggestion-item-select']);
MultiInput.displayName = 'MultiInput';
MultiInput.defaultProps = {
  type: InputType.Text,
  valueState: ValueState.None
};
export { MultiInput };